import { get } from 'lodash';
import { buildNewsComponents, isRumorTitle } from '@tencent/qb-preload-utils';
import Aegis from './aegis';
import H5RecordUnitTime from './reportUnitTime';
// import { postMessage, isHippy } from './index'; // 测试Hippy框架时用的【保留，后续删除】

// eslint-disable-next-line import/prefer-default-export
export const isCSR = __CLIENT__ && /\/csrarticle/.test(location.pathname);

const getNetworkType = async () => {
  const getType = get(window, 'browser.connection.getType', () => {});
  return new Promise((resolve) => {
    let networkType;
    getType((networkStr) => {
      console.warn('zloong networkStr=', networkStr);
      switch (networkStr) {
        case 'wifi':
          networkType = 'wifi';
          break;
        case '5g':
          networkType = '5g';
          break;
        case '4g':
          networkType = '4g';
          break;
        case '3g':
        case '3gnet':
          networkType = '3g';
          break;
        case '2g':
          networkType = '2g';
          break;
        default:
          networkType = 'other';
      }
      resolve(networkType);
    });
  });
};

export const reportPipeLogs = {};
export const reportPipeKeys = {
  preloadTimeout: 'preloadTimeout', // 预缓存数据超时
  preloadSucc: 'preloadSucc', // 预缓存数据成功
  preloadErr: 'preloadErr', // 预缓存数据失败
  getDataById: 'getDataById', // 传入的docId
  getDataRet: 'getDataRet', // 返回状态
  getDataCatchErr: 'getDataCatchErr', // 获取数据错误
  hitPreload: 'hitPreload', // 是否命中预拉取
  getDataTimeNum: 'getDataTimeNum', // 获取数据耗时
  memLruCacheGet: 'memLruCacheGet', // api是否存在
  injectAssetTime: 'injectAssetTime', // 终端触发时间
  clikStartTime: 'clikStartTime', // 用户点击时间
  firstWPaint: 'firstWPaint', // 首字渲染时间
  platform: '__platform', // 平台ios/android
  network: '__network', // 网络2g/3g/4g/5g/wifi
  templateType: 'templateType', // 模板类型【0|在线，1|cdn资源，2|in内嵌资源】
  mainJsLoadTime: 'mainJsLoadTime', // 主JS加载完成时间
  mainJsStartTime: 'mainJsStartTime', // 主JS开始执行时间
  articleEndPaint: 'articleEndPaint', // 文章底部一个节点渲染时间
  articleHeightMut: 'articleHeightMut', // 文章内容高度突变时间点
  articleEndMarkMut: 'articleEndMarkMut', // 文章底部MutationObserver时间
  firstWPaint_clikStartTime: 'firstWPaint_clikStartTime', // 点击到首屏渲染耗时
  articleEndPaint_clikStartTime: 'articleEndPaint_clikStartTime',
  articleHeightMut_clikStartTime: 'articleHeightMut_clikStartTime',
  articleEndMarkMut_clikStartTime: 'articleEndMarkMut_clikStartTime',
};
/**
 * 生成供 React 组件使用的 props
 * @param  {Array} contentFields     article from ListApp
 * @param  {Object} CCOpts  兼容内容中心配置
 * @param  {Object} searchOpts 正文查询参数
 * @return {String}
 */
const buildFieldComponents = (contentFields, CCOpts = {}, searchOpts = {}) => {
  return buildNewsComponents(contentFields, CCOpts, searchOpts, () => {});
};
/**
 * 模拟获取本地数据
 */
const getPreloadDataAsync = (docId = '') => {
  return new Promise((resolve) => {
    // window.getPreloadData = (data) => { // 测试Hippy框架时用的【保留，后续删除】
    //   resolve(data);
    // };
    const finalTimer = setTimeout(() => {
      resolve({});
      reportPipeLogs[reportPipeKeys.preloadTimeout] = 1;
    }, 500); // 200
    // jsapi方式读取数据
    const memLruCacheGet = get(window, 'browser.nativecache.memLruCacheGet', null);
    const isAndroid = /android/gi.test(navigator.userAgent);
    if (memLruCacheGet) {
      memLruCacheGet(
        (success) => {
          const rsp = isAndroid ? decodeURIComponent(success) : success;
          resolve(rsp);
          clearTimeout(finalTimer);
          reportPipeLogs[reportPipeKeys.preloadSucc] = 1;
        },
        (err) => {
          resolve({});
          clearTimeout(finalTimer);
          reportPipeLogs[reportPipeKeys.preloadErr] = err;
        },
        {
          cacheName: 'infoCache',
          key: docId,
        },
      );
    }
    reportPipeLogs[reportPipeKeys.memLruCacheGet] = !!memLruCacheGet + 0;
    // if (!isHippy()) { // 测试Hippy框架时用的【保留，后续删除】
    //   console.error('zloong isHippy');
    //   // 暂时用Mock模拟数据
    //   const data = require(`../entries/csr-article/mock/preload_${docId}.js`).default;
    //   console.error('zloong isHippy data=', data);
    //   resolve(data);
    // }

    // ..读取本地数据
    // const data = require(`../entries/csr-article/mock/preload_3966592535844550978.js`).default;
    // console.error('zloong isHippy data=', data);
    // resolve(data);
  });
};

export const getDataByIdMock = (docId = '') =>
  new Promise((resolve, reject) => {
    try {
      reportPipeLogs[reportPipeKeys.getDataById] = docId;
      if (!docId) {
        reject(null);
      } else {
        getPreloadDataAsync(docId)
          .then(async (res) => {
            const data = typeof res === 'string' ? JSON.parse(res) : res;
            const { return: ret = '', cacheObject: { eType = '', sData = '' } = {} } = data;
            reportPipeLogs[reportPipeKeys.getDataRet] = ret;
            if (ret === 0 && eType === 0 && sData) {
              const article = JSON.parse(sData);
              const { vContentField = [], bUseHtml, sHtmlContent, sJsonContent } = article;
              const apn = await getNetworkType();
              const contentFields = buildFieldComponents(
                vContentField,
                {
                  bUseHtml,
                  sHtmlContent,
                  sJsonContent,
                  isHtml: false,
                },
                { docId, apn },
              );
              if (typeof contentFields === 'object') {
                contentFields
                  .filter(({ type }) => type === 'image')
                  .forEach((item) => {
                    let _src = apn === 'wifi' ? item.srcHD : item.srcSized;
                    _src = _src.replace('http', 'https'); // https 转换
                    Object.assign(item, {
                      // 非 wifi 情况下使用压缩图片
                      src: _src,
                    });
                  });
              }
              resolve({
                contentFields,
                isRumorTitle: isRumorTitle(),
                ...article,
                isPreloadData: true,
              });
            } else {
              resolve(null);
            }
          })
          .catch(reject);
        // setTimeout(() => { // 测试Hippy框架时用的【保留，后续删除】
        //   // 微任务
        //   postMessage(
        //     JSON.stringify({
        //       func: 'coolread.getPreloadData',
        //       data: {},
        //     }),
        //   );
        // });
      }
    } catch (e) {
      reject(null);
      reportPipeLogs[reportPipeKeys.getDataCatchErr] = e;
    }
  });
const getPlatform = () => {
  const ua = navigator.userAgent;
  if (/android/gi.test(ua)) return 'android';
  if (/iphone|ipod|iPad/gi.test(ua)) return 'ios';
  return 'other';
};

if (isCSR) {
  // 执行上报
  let hasReport = false;
  const rptUnitTime = new H5RecordUnitTime();
  rptUnitTime.reportUnitTime();
  document.addEventListener('visibilitychange', async () => {
    if (hasReport) return;
    reportPipeLogs[reportPipeKeys.injectAssetTime] = window.injectAssetTime || 0;
    reportPipeLogs[reportPipeKeys.clikStartTime] = window.clikStartTime || 0;
    reportPipeLogs[reportPipeKeys.firstWPaint] = window.firstWPaint || 0;
    reportPipeLogs[reportPipeKeys.platform] = getPlatform();
    reportPipeLogs[reportPipeKeys.network] = await getNetworkType();
    reportPipeLogs[reportPipeKeys.mainJsLoadTime] = window.mainJsLoadTime || 0;
    reportPipeLogs[reportPipeKeys.mainJsStartTime] = window.mainJsStartTime || 0;
    reportPipeLogs[reportPipeKeys.articleEndPaint] = window.articleEndPaint || 0;
    reportPipeLogs[reportPipeKeys.articleHeightMut] = window.articleHeightMut || 0;
    reportPipeLogs[reportPipeKeys.articleEndMarkMut] = window.articleEndMarkMut || 0;
    reportPipeLogs[reportPipeKeys.templateType] = window.templateType || 0;
    Object.keys(reportPipeKeys).forEach((key) => {
      if (/_/.test(key)) {
        const keys = key.split('_');
        reportPipeLogs[key] =
          reportPipeLogs[keys[0]] && reportPipeLogs[keys[1]] ? reportPipeLogs[keys[0]] - reportPipeLogs[keys[1]] : 0;
      }
    });
    // 灯塔
    window?.newsNodeBeaconAction?.onDirectUserAction?.('TbirdPipeLogs', reportPipeLogs);
    // aegis
    Aegis?.infoAll(`_h5 csr-article reportPipeLogs:${JSON.stringify(reportPipeLogs)}`);
    hasReport = true;
  });
}

export function getTBirdUrl(url) {
  return `qb://tbird?contenturl=${encodeURIComponent(url)}`;
}
